import { render, staticRenderFns } from "./CopeWith.vue?vue&type=template&id=b0a887a6&scoped=true"
import script from "./CopeWith.vue?vue&type=script&lang=js"
export * from "./CopeWith.vue?vue&type=script&lang=js"
import style0 from "./CopeWith.vue?vue&type=style&index=0&id=b0a887a6&lang=less&scoped=true"
import style1 from "./CopeWith.vue?vue&type=style&index=1&id=b0a887a6&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a887a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b0a887a6')) {
      api.createRecord('b0a887a6', component.options)
    } else {
      api.reload('b0a887a6', component.options)
    }
    module.hot.accept("./CopeWith.vue?vue&type=template&id=b0a887a6&scoped=true", function () {
      api.rerender('b0a887a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/const/CopeWith.vue"
export default component.exports